module.exports = __webpack_public_path__ + "u9.no2.a0dabadb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/nakagawa/u9.no2.jpg
// module id = s59z
// module chunks = 0